export default __webpack_public_path__ + "static/media/falinks.104c240a.jpeg";